import React from 'react';
import PropTypes from 'prop-types';
import './element.scss';

import { set, clear } from './map';

class ScrollElement extends React.Component {
  componentDidMount() {
    set(this.props.name, this.node);
  }

  componentWillUnmount() {
    clear(this.props.name);
  }

  render() {
    return (
      <section
        ref={node => {
          this.node = node;
        }}
        data-test={this.props['data-test']}
        className={this.props.className}
      >
        {this.props.children}
      </section>
    );
  }
}

const { node, string } = PropTypes;

ScrollElement.propTypes = {
  name: string.isRequired,
  children: node,
  'data-test': string,
  className: string,
};

ScrollElement.defaultProps = {
  children: null,
  'data-test': undefined,
  className: undefined,
};

export default ScrollElement;
